import {
  createNewUserId,
  cleanupDatabase,
  searchUser,
} from "./UsersCleanFunctions";
import { findNodeById } from "./OrgTreeFunctions";
import { generateDateArray } from "./TimeFunctions";

const testReportDatabase = [
  {
    nameOne: "Elly",
    nameTwo: "Tim",
    isTheSameName: false,
  },
  {
    nameOne: "Elly",
    nameTwo: "Michelle",
    isTheSameName: false,
  },
  {
    nameOne: "Tim",
    nameTwo: "Michelle",
    isTheSameName: false,
  },
  {
    nameOne: "Andrew",
    nameTwo: "Michael",
    isTheSameName: false,
  },
  {
    nameOne: "Andrew",
    nameTwo: "Bull",
    isTheSameName: false,
  },
  {
    nameOne: "Andrew",
    nameTwo: "Ewikowski",
    isTheSameName: false,
  },
  {
    nameOne: "Barker",
    nameTwo: "Kohring",
    isTheSameName: false,
  },
  {
    nameOne: "Beale",
    nameTwo: "February",
    isTheSameName: false,
  },
  {
    nameOne: "Joey",
    nameTwo: "Adriana",
    isTheSameName: false,
  },
  {
    nameOne: "Bognar",
    nameTwo: "Preece",
    isTheSameName: false,
  },
  {
    nameOne: "Allan",
    nameTwo: "Wendy",
    isTheSameName: false,
  },
  {
    nameOne: "Brown",
    nameTwo: "Kelly",
    isTheSameName: false,
  },
  {
    nameOne: "Bull",
    nameTwo: "Ewikowski",
    isTheSameName: false,
  },
  {
    nameOne: "Bunn",
    nameTwo: "Were",
    isTheSameName: false,
  },
  {
    nameOne: "Cherie",
    nameTwo: "Ben",
    isTheSameName: false,
  },
  {
    nameOne: "Burns",
    nameTwo: "Dunn",
    isTheSameName: false,
  },
  {
    nameOne: "Burns",
    nameTwo: "Jarvis",
    isTheSameName: false,
  },
  {
    nameOne: "Sandy",
    nameTwo: "Peter",
    isTheSameName: false,
  },
  {
    nameOne: "Crafts",
    nameTwo: "Edwards",
    isTheSameName: false,
  },
  {
    nameOne: "Crafts",
    nameTwo: "Hoare",
    isTheSameName: false,
  },
  {
    nameOne: "Cronin",
    nameTwo: "Lengkong",
    isTheSameName: false,
  },
  {
    nameOne: "Cronin",
    nameTwo: "Randell",
    isTheSameName: false,
  },
  {
    nameOne: "Crouch",
    nameTwo: "Glenister",
    isTheSameName: false,
  },
  {
    nameOne: "Lorene",
    nameTwo: "Louis",
    isTheSameName: false,
  },
  {
    nameOne: "Cvetanovic",
    nameTwo: "Hunt",
    isTheSameName: false,
  },
  {
    nameOne: "Damianopoulos",
    nameTwo: "Smith",
    isTheSameName: false,
  },
  {
    nameOne: "Kmy",
    nameTwo: "Jonathan",
    isTheSameName: false,
  },
  {
    nameOne: "Di mauro",
    nameTwo: "Thomas",
    isTheSameName: false,
  },
  {
    nameOne: "Ben",
    nameTwo: "Cara",
    isTheSameName: false,
  },
  {
    nameOne: "Dunn",
    nameTwo: "Jarvis",
    isTheSameName: false,
  },
  {
    nameOne: "David",
    nameTwo: "Deanne",
    isTheSameName: false,
  },
  {
    nameOne: "Edwards",
    nameTwo: "Hoare",
    isTheSameName: false,
  },
  {
    nameOne: "Michelle",
    nameTwo: "Manfred",
    isTheSameName: false,
  },
  {
    nameOne: "Dwayne",
    nameTwo: "Celeste",
    isTheSameName: false,
  },
  {
    nameOne: "Nick",
    nameTwo: "Val",
    isTheSameName: false,
  },
  {
    nameOne: "Hilton",
    nameTwo: "Liesl",
    isTheSameName: false,
  },
  {
    nameOne: "Hilton",
    nameTwo: "Nicky",
    isTheSameName: false,
  },
  {
    nameOne: "Liesl",
    nameTwo: "Nicky",
    isTheSameName: false,
  },
  {
    nameOne: "Stephen",
    nameTwo: "Kathryn",
    isTheSameName: false,
  },
  {
    nameOne: "Foster",
    nameTwo: "Ram",
    isTheSameName: false,
  },
  {
    nameOne: "Goode",
    nameTwo: "Lindley",
    isTheSameName: false,
  },
  {
    nameOne: "Gunek",
    nameTwo: "Manansang",
    isTheSameName: false,
  },
  {
    nameOne: "Hawthorne",
    nameTwo: "Moore",
    isTheSameName: false,
  },
  {
    nameOne: "Hollands",
    nameTwo: "Orr",
    isTheSameName: false,
  },
  {
    nameOne: "Ben",
    nameTwo: "Bec",
    isTheSameName: false,
  },
  {
    nameOne: "Jarvis",
    nameTwo: "Wood",
    isTheSameName: false,
  },
  {
    nameOne: "Rebecca",
    nameTwo: "Matthew",
    isTheSameName: false,
  },
  {
    nameOne: "Jones",
    nameTwo: "Tinker",
    isTheSameName: false,
  },
  {
    nameOne: "Denise",
    nameTwo: "Lauren",
    isTheSameName: false,
  },
  {
    nameOne: "Denise",
    nameTwo: "Daniel",
    isTheSameName: false,
  },
  {
    nameOne: "Lauren",
    nameTwo: "Daniel",
    isTheSameName: false,
  },
  {
    nameOne: "Kahika",
    nameTwo: "Koblischke",
    isTheSameName: false,
  },
  {
    nameOne: "Lengkong",
    nameTwo: "Randell",
    isTheSameName: false,
  },
  {
    nameOne: "Jane",
    nameTwo: "Leonard",
    isTheSameName: false,
  },
  {
    nameOne: "Lewis",
    nameTwo: "Willis",
    isTheSameName: false,
  },
  {
    nameOne: "Mcaulay",
    nameTwo: "Mcdonnell",
    isTheSameName: false,
  },
  {
    nameOne: "Mcaulay",
    nameTwo: "Parker",
    isTheSameName: false,
  },
  {
    nameOne: "Mcdonnell",
    nameTwo: "Parker",
    isTheSameName: false,
  },
  {
    nameOne: "Sally",
    nameTwo: "Rose",
    isTheSameName: false,
  },
  {
    nameOne: "Naidoo",
    nameTwo: "Soh",
    isTheSameName: false,
  },
  {
    nameOne: "Eddie",
    nameTwo: "Rachael",
    isTheSameName: false,
  },
  {
    nameOne: "Kathryn",
    nameTwo: "Nigel",
    isTheSameName: false,
  },
  {
    nameOne: "Jacinda",
    nameTwo: "Benjamin",
    isTheSameName: false,
  },
  {
    nameOne: "Julie",
    nameTwo: "Terry",
    isTheSameName: false,
  },
  {
    nameOne: "Alana",
    nameTwo: "Elli",
    isTheSameName: false,
  },
  {
    nameOne: "Alana",
    nameTwo: "Artie",
    isTheSameName: false,
  },
  {
    nameOne: "Elli",
    nameTwo: "Artie",
    isTheSameName: false,
  },
  {
    nameOne: "Karen",
    nameTwo: "Amber",
    isTheSameName: false,
  },
  {
    nameOne: "Rob",
    nameTwo: "Amanda",
    isTheSameName: false,
  },
  {
    nameOne: "Janet",
    nameTwo: "Kylie",
    isTheSameName: false,
  },
  {
    nameOne: "Robyn",
    nameTwo: "Noel",
    isTheSameName: false,
  },
  {
    nameOne: "Maureen",
    nameTwo: "Marty",
    isTheSameName: false,
  },
  {
    nameOne: "Felton",
    nameTwo: "Felton ",
    isTheSameName: true,
  },
  {
    nameOne: "Felton",
    nameTwo: "Felt9n",
    isTheSameName: true,
  },
  {
    nameOne: "Hawthorne",
    nameTwo: "Moore ",
    isTheSameName: false,
  },
  {
    nameOne: "Jones",
    nameTwo: "Jones",
    isTheSameName: true,
  },
  {
    nameOne: "Lex",
    nameTwo: "Lex ",
    isTheSameName: true,
  },
  {
    nameOne: "Moore",
    nameTwo: "Moore ",
    isTheSameName: true,
  },
  {
    nameOne: "Katie",
    nameTwo: "Katie ",
    isTheSameName: true,
  },
  {
    nameOne: "Mcelrea ",
    nameTwo: "Mcelrea ",
    isTheSameName: true,
  },
  {
    nameOne: "Clancy",
    nameTwo: "Clancy",
    isTheSameName: true,
  },
  {
    nameOne: "Mcelrea",
    nameTwo: "Mcelrea",
    isTheSameName: true,
  },
  {
    nameOne: "Moore",
    nameTwo: "Moore",
    isTheSameName: true,
  },
  {
    nameOne: "Randell",
    nameTwo: "Randell",
    isTheSameName: true,
  },
  {
    nameOne: "Aghajanian",
    nameTwo: "Aghjanian",
    isTheSameName: true,
  },
  {
    nameOne: "Alder",
    nameTwo: "Aldee",
    isTheSameName: true,
  },
  {
    nameOne: "Andrew",
    nameTwo: "Elly",
    isTheSameName: false,
  },
  {
    nameOne: "Andrew",
    nameTwo: "Hagenaar",
    isTheSameName: false,
  },
  {
    nameOne: "Andrew",
    nameTwo: "Fergusson",
    isTheSameName: false,
  },
  {
    nameOne: "Audrey",
    nameTwo: "Audrey`",
    isTheSameName: true,
  },
  {
    nameOne: "Barry",
    nameTwo: "Smith",
    isTheSameName: false,
  },
  {
    nameOne: "Benn",
    nameTwo: "Benn (wednesday)",
    isTheSameName: true,
  },
  {
    nameOne: "Betham",
    nameTwo: "Lala",
    isTheSameName: false,
  },
  {
    nameOne: "Brinsden",
    nameTwo: "Brinsde",
    isTheSameName: true,
  },
  {
    nameOne: "Brinsden",
    nameTwo: "Gek",
    isTheSameName: false,
  },
  {
    nameOne: "Brinsden",
    nameTwo: "Todd",
    isTheSameName: false,
  },
  {
    nameOne: "Brown",
    nameTwo: "Rown",
    isTheSameName: true,
  },
  {
    nameOne: "Bull",
    nameTwo: "Fergusson",
    isTheSameName: false,
  },
  {
    nameOne: "Bunn",
    nameTwo: "Taylor",
    isTheSameName: false,
  },
  {
    nameOne: "Burns",
    nameTwo: "Little",
    isTheSameName: false,
  },
  {
    nameOne: "Kenelm",
    nameTwo: "Eugenie",
    isTheSameName: false,
  },
  {
    nameOne: "Kenelm",
    nameTwo: "Joel",
    isTheSameName: false,
  },
  {
    nameOne: "Clancy",
    nameTwo: "Hinchlidde",
    isTheSameName: false,
  },
  {
    nameOne: "Clancy",
    nameTwo: "Hinchliffe",
    isTheSameName: false,
  },
  {
    nameOne: "Clancy",
    nameTwo: "Cunningham",
    isTheSameName: false,
  },
  {
    nameOne: "Coleman",
    nameTwo: "Cokeman",
    isTheSameName: true,
  },
  {
    nameOne: "Janie",
    nameTwo: "Jamie",
    isTheSameName: true,
  },
  {
    nameOne: "David",
    nameTwo: "Dave",
    isTheSameName: true,
  },
  {
    nameOne: "Crafts",
    nameTwo: "Edwards (wednesday 10th)",
    isTheSameName: false,
  },
  {
    nameOne: "Crafts",
    nameTwo: "Jurgensen",
    isTheSameName: false,
  },
  {
    nameOne: "Cronin",
    nameTwo: "Glass",
    isTheSameName: false,
  },
  {
    nameOne: "Crouch",
    nameTwo: "Chee",
    isTheSameName: false,
  },
  {
    nameOne: "Crouch",
    nameTwo: "Mclean",
    isTheSameName: false,
  },
  {
    nameOne: "Crouch",
    nameTwo: "White",
    isTheSameName: false,
  },
  {
    nameOne: "Suzy",
    nameTwo: "Joshua",
    isTheSameName: false,
  },
  {
    nameOne: "Cutmore",
    nameTwo: "Cutmroe",
    isTheSameName: true,
  },
  {
    nameOne: "Damianopoulos",
    nameTwo: "Damianopolous",
    isTheSameName: true,
  },
  {
    nameOne: "Damianopoulos",
    nameTwo: "Triggs",
    isTheSameName: false,
  },
  {
    nameOne: "Deng",
    nameTwo: "Yam",
    isTheSameName: false,
  },
  {
    nameOne: "Dixon",
    nameTwo: "Dixo",
    isTheSameName: true,
  },
  {
    nameOne: "Dunn",
    nameTwo: "Little",
    isTheSameName: false,
  },
  {
    nameOne: "Ben",
    nameTwo: "Benjamin",
    isTheSameName: true,
  },
  {
    nameOne: "Edwards",
    nameTwo: "Jurgensen",
    isTheSameName: false,
  },
  {
    nameOne: "David",
    nameTwo: "Deborah",
    isTheSameName: false,
  },
  {
    nameOne: "David",
    nameTwo: "Hannah",
    isTheSameName: false,
  },
  {
    nameOne: "David",
    nameTwo: "Lily",
    isTheSameName: false,
  },
  {
    nameOne: "Deanne",
    nameTwo: "Deborah",
    isTheSameName: false,
  },
  {
    nameOne: "Deanne",
    nameTwo: "Hannah",
    isTheSameName: false,
  },
  {
    nameOne: "Deanne",
    nameTwo: "Lily",
    isTheSameName: false,
  },
  {
    nameOne: "Ewikowski",
    nameTwo: "Fergusson",
    isTheSameName: false,
  },
  {
    nameOne: "Feebrey",
    nameTwo: "Chan",
    isTheSameName: false,
  },
  {
    nameOne: "Felton",
    nameTwo: "Khiroya",
    isTheSameName: false,
  },
  {
    nameOne: "Felton",
    nameTwo: "Rough",
    isTheSameName: false,
  },
  {
    nameOne: "Felton",
    nameTwo: "Todd",
    isTheSameName: false,
  },
  {
    nameOne: "Field",
    nameTwo: "Mcglone",
    isTheSameName: false,
  },
  {
    nameOne: "Field",
    nameTwo: "Mcglones",
    isTheSameName: false,
  },
  {
    nameOne: "Field",
    nameTwo: "Wyborn",
    isTheSameName: false,
  },
  {
    nameOne: "Foong",
    nameTwo: "Lawler",
    isTheSameName: false,
  },
  {
    nameOne: "Foster",
    nameTwo: "Refalo",
    isTheSameName: false,
  },
  {
    nameOne: "Alisya",
    nameTwo: "Katie",
    isTheSameName: false,
  },
  {
    nameOne: "Alisya",
    nameTwo: "Katoe",
    isTheSameName: false,
  },
  {
    nameOne: "Glenister",
    nameTwo: "Chee",
    isTheSameName: false,
  },
  {
    nameOne: "Glenister",
    nameTwo: "Mclean",
    isTheSameName: false,
  },
  {
    nameOne: "Glenister",
    nameTwo: "White",
    isTheSameName: false,
  },
  {
    nameOne: "Serge",
    nameTwo: "Sege",
    isTheSameName: true,
  },
  {
    nameOne: "Gunek",
    nameTwo: "Skewes",
    isTheSameName: false,
  },
  {
    nameOne: "Kerith",
    nameTwo: "Tim",
    isTheSameName: false,
  },
  {
    nameOne: "Hawthorne",
    nameTwo: "Cawthorn",
    isTheSameName: false,
  },
  {
    nameOne: "Hawthorne",
    nameTwo: "Cawthorn  30th-6thjuly",
    isTheSameName: true,
  },
  {
    nameOne: "Hawthorne",
    nameTwo: "Cawthorn 4th-8th november",
    isTheSameName: true,
  },
  {
    nameOne: "Hawthorne",
    nameTwo: "Colley",
    isTheSameName: false,
  },
  {
    nameOne: "Hawthorne",
    nameTwo: "Longmire",
    isTheSameName: false,
  },
  {
    nameOne: "Hawthorne",
    nameTwo: "Sapuppo",
    isTheSameName: false,
  },
  {
    nameOne: "Hoare",
    nameTwo: "Edwards (wednesday 10th)",
    isTheSameName: false,
  },
  {
    nameOne: "Hoare",
    nameTwo: "Jurgensen",
    isTheSameName: false,
  },
  {
    nameOne: "Melanie",
    nameTwo: "Sue",
    isTheSameName: false,
  },
  {
    nameOne: "Anne",
    nameTwo: "Luke",
    isTheSameName: false,
  },
  {
    nameOne: "Jarvis",
    nameTwo: "Little",
    isTheSameName: false,
  },
  {
    nameOne: "Jarvis",
    nameTwo: "Jarvos",
    isTheSameName: true,
  },
  {
    nameOne: "Hannah",
    nameTwo: "Gavin",
    isTheSameName: false,
  },
  {
    nameOne: "Johnson",
    nameTwo: "Edwards",
    isTheSameName: false,
  },
  {
    nameOne: "Johnson",
    nameTwo: "Redman",
    isTheSameName: false,
  },
  {
    nameOne: "Rebecca",
    nameTwo: "Mat",
    isTheSameName: false,
  },
  {
    nameOne: "Rebecca",
    nameTwo: "Matt",
    isTheSameName: false,
  },
  {
    nameOne: "Jones",
    nameTwo: "Buckle",
    isTheSameName: false,
  },
  {
    nameOne: "Jones",
    nameTwo: "Rey",
    isTheSameName: false,
  },
  {
    nameOne: "Matthew",
    nameTwo: "Mat",
    isTheSameName: true,
  },
  {
    nameOne: "Denise",
    nameTwo: "Andrew",
    isTheSameName: false,
  },
  {
    nameOne: "Kahika",
    nameTwo: "Ackroyd",
    isTheSameName: true,
  },
  {
    nameOne: "Kahika",
    nameTwo: "Kiernan",
    isTheSameName: false,
  },
  {
    nameOne: "Kahika",
    nameTwo: "Sckroyd",
    isTheSameName: false,
  },
  {
    nameOne: "Denise",
    nameTwo: "Leah",
    isTheSameName: false,
  },
  {
    nameOne: "Lauren",
    nameTwo: "Andrew",
    isTheSameName: false,
  },
  {
    nameOne: "Lauren",
    nameTwo: "Leah",
    isTheSameName: false,
  },
  {
    nameOne: "Daniel",
    nameTwo: "Andrew",
    isTheSameName: false,
  },
  {
    nameOne: "Kahika",
    nameTwo: "Cabrera",
    isTheSameName: false,
  },
  {
    nameOne: "Daniel",
    nameTwo: "Leah",
    isTheSameName: false,
  },
  {
    nameOne: "Kong",
    nameTwo: "Moosa",
    isTheSameName: false,
  },
  {
    nameOne: "Lalagavesi",
    nameTwo: "Lala",
    isTheSameName: true,
  },
  {
    nameOne: "Lammiman",
    nameTwo: "Lammimam",
    isTheSameName: true,
  },
  {
    nameOne: "Lengkong",
    nameTwo: "Glass",
    isTheSameName: false,
  },
  {
    nameOne: "Jane",
    nameTwo: "Jjane",
    isTheSameName: true,
  },
  {
    nameOne: "Lewis",
    nameTwo: "Steer",
    isTheSameName: false,
  },
  {
    nameOne: "Alan",
    nameTwo: "Akan",
    isTheSameName: true,
  },
  {
    nameOne: "Roberto",
    nameTwo: "Roby",
    isTheSameName: true,
  },
  {
    nameOne: "Lyon",
    nameTwo: "Lyom",
    isTheSameName: true,
  },
  {
    nameOne: "Manansang",
    nameTwo: "Skewes",
    isTheSameName: false,
  },
  {
    nameOne: "Sally",
    nameTwo: "Brian",
    isTheSameName: false,
  },
  {
    nameOne: "Rose",
    nameTwo: "Brian",
    isTheSameName: false,
  },
  {
    nameOne: "Drew",
    nameTwo: "Andrew",
    isTheSameName: true,
  },
  {
    nameOne: "Michael",
    nameTwo: "Hagenaar",
    isTheSameName: false,
  },
  {
    nameOne: "Moore",
    nameTwo: "Cawthorn",
    isTheSameName: false,
  },
  {
    nameOne: "Moore",
    nameTwo: "Cawthorn 28th-1st november",
    isTheSameName: false,
  },
  {
    nameOne: "Moore",
    nameTwo: "Cawthorn 7th-13th",
    isTheSameName: false,
  },
  {
    nameOne: "Moore",
    nameTwo: "Colley",
    isTheSameName: false,
  },
  {
    nameOne: "Moore",
    nameTwo: "Longmire",
    isTheSameName: false,
  },
  {
    nameOne: "Moore",
    nameTwo: "Sapuppo",
    isTheSameName: false,
  },
  {
    nameOne: "Moss",
    nameTwo: "Martinez",
    isTheSameName: false,
  },
  {
    nameOne: "Amy",
    nameTwo: "Ameshri",
    isTheSameName: true,
  },
  {
    nameOne: "Naidoo",
    nameTwo: "Willcocks",
    isTheSameName: false,
  },
  {
    nameOne: "Gaye",
    nameTwo: "Bruce",
    isTheSameName: false,
  },
  {
    nameOne: "Pauline",
    nameTwo: "Isaac",
    isTheSameName: false,
  },
  {
    nameOne: "Robert",
    nameTwo: "Robby",
    isTheSameName: true,
  },
  {
    nameOne: "Robert",
    nameTwo: "Robwrt",
    isTheSameName: true,
  },
  {
    nameOne: "Portwin",
    nameTwo: "Perumal",
    isTheSameName: false,
  },
  {
    nameOne: "Portwin",
    nameTwo: "Reid",
    isTheSameName: false,
  },
  {
    nameOne: "Randell",
    nameTwo: "Glass",
    isTheSameName: false,
  },
  {
    nameOne: "Renae",
    nameTwo: "Amanda",
    isTheSameName: false,
  },
  {
    nameOne: "Rapana",
    nameTwo: "Rapana-jenkins",
    isTheSameName: true,
  },
  {
    nameOne: "Rkyek",
    nameTwo: "R'kyek",
    isTheSameName: true,
  },
  {
    nameOne: "Sangster",
    nameTwo: "Dunn (week ending 19th)",
    isTheSameName: false,
  },
  {
    nameOne: "Dunn",
    nameTwo: "Dunn (week ending 19th)",
    isTheSameName: true,
  },
  {
    nameOne: "Scott",
    nameTwo: "Scott wed",
    isTheSameName: true,
  },
  {
    nameOne: "Smith",
    nameTwo: "Smitg",
    isTheSameName: true,
  },
  {
    nameOne: "Karen",
    nameTwo: "Susan",
    isTheSameName: false,
  },
  {
    nameOne: "Amber",
    nameTwo: "Susan",
    isTheSameName: false,
  },
  {
    nameOne: "Soh",
    nameTwo: "Naid00",
    isTheSameName: false,
  },
  {
    nameOne: "Soh",
    nameTwo: "Willcocks",
    isTheSameName: false,
  },
  {
    nameOne: "Stanmore",
    nameTwo: "O",
    isTheSameName: false,
  },
  {
    nameOne: "Stanmore",
    nameTwo: "Rapana",
    isTheSameName: false,
  },
  {
    nameOne: "Sugunarajan",
    nameTwo: "Cunningham",
    isTheSameName: false,
  },
  {
    nameOne: "Janet",
    nameTwo: "Sibi",
    isTheSameName: false,
  },
  {
    nameOne: "Kylie",
    nameTwo: "Sibi",
    isTheSameName: false,
  },
  {
    nameOne: "Tinker",
    nameTwo: "Buckle",
    isTheSameName: false,
  },
  {
    nameOne: "Tinker",
    nameTwo: "Rey",
    isTheSameName: false,
  },
  {
    nameOne: "Van heel",
    nameTwo: "Cartledge",
    isTheSameName: false,
  },
  {
    nameOne: "Van heel",
    nameTwo: "Kahika",
    isTheSameName: false,
  },
  {
    nameOne: "Van heel",
    nameTwo: "Midson",
    isTheSameName: false,
  },
  {
    nameOne: "Van heel",
    nameTwo: "Vanheel",
    isTheSameName: false,
  },
  {
    nameOne: "Van heel",
    nameTwo: "Warner",
    isTheSameName: false,
  },
  {
    nameOne: "Ross",
    nameTwo: "Jan",
    isTheSameName: false,
  },
  {
    nameOne: "Were",
    nameTwo: "Taylor",
    isTheSameName: false,
  },
  {
    nameOne: "Rosemary",
    nameTwo: "Rosemaru",
    isTheSameName: true,
  },
  {
    nameOne: "Willis",
    nameTwo: "Steer",
    isTheSameName: false,
  },
  {
    nameOne: "Alam",
    nameTwo: "Alan",
    isTheSameName: true,
  },
  {
    nameOne: "Ribins",
    nameTwo: "Robins",
    isTheSameName: true,
  },
  {
    nameOne: "Allen",
    nameTwo: "Renee",
    isTheSameName: false,
  },
  {
    nameOne: "Aldous",
    nameTwo: "Y",
    isTheSameName: false,
  },
  {
    nameOne: "Naid00",
    nameTwo: "Naidoo",
    isTheSameName: true,
  },
  {
    nameOne: "Naid00",
    nameTwo: "Willcocks",
    isTheSameName: false,
  },
  {
    nameOne: "Cartledge",
    nameTwo: "Kahika",
    isTheSameName: false,
  },
  {
    nameOne: "Cartledge",
    nameTwo: "Midson",
    isTheSameName: false,
  },
  {
    nameOne: "Cartledge",
    nameTwo: "Vanheel",
    isTheSameName: false,
  },
  {
    nameOne: "Cartledge",
    nameTwo: "Warner",
    isTheSameName: false,
  },
  {
    nameOne: "Andrew",
    nameTwo: "Rachel",
    isTheSameName: false,
  },
  {
    nameOne: "Kahika",
    nameTwo: "Midson",
    isTheSameName: false,
  },
  {
    nameOne: "Kahika",
    nameTwo: "Vanheel",
    isTheSameName: false,
  },
  {
    nameOne: "Kahika",
    nameTwo: "Warner",
    isTheSameName: false,
  },
  {
    nameOne: "Andrew",
    nameTwo: "Leah",
    isTheSameName: false,
  },
  {
    nameOne: "Midson",
    nameTwo: "Vanheel",
    isTheSameName: false,
  },
  {
    nameOne: "Midson",
    nameTwo: "Warner",
    isTheSameName: false,
  },
  {
    nameOne: "Vanheel",
    nameTwo: "Warner",
    isTheSameName: false,
  },
  {
    nameOne: "Andrew",
    nameTwo: "Guy",
    isTheSameName: false,
  },
  {
    nameOne: "Anna",
    nameTwo: "Peter",
    isTheSameName: false,
  },
  {
    nameOne: "Annie",
    nameTwo: "Corinne",
    isTheSameName: false,
  },
  {
    nameOne: "Stahorn",
    nameTwo: "Strahorn",
    isTheSameName: true,
  },
  {
    nameOne: "Ben",
    nameTwo: "Harrison",
    isTheSameName: false,
  },
  {
    nameOne: "Medwin",
    nameTwo: "Siawarta",
    isTheSameName: false,
  },
  {
    nameOne: "Bronte",
    nameTwo: "Sam",
    isTheSameName: false,
  },
  {
    nameOne: "Carly",
    nameTwo: "Joe",
    isTheSameName: false,
  },
  {
    nameOne: "Chris",
    nameTwo: "Riley",
    isTheSameName: false,
  },
  {
    nameOne: "Darrel",
    nameTwo: "Desley",
    isTheSameName: false,
  },
  {
    nameOne: "Edwards (wednesday 10th)",
    nameTwo: "Edwards",
    isTheSameName: true,
  },
  {
    nameOne: "Edwards (wednesday 10th)",
    nameTwo: "Jurgensen",
    isTheSameName: false,
  },
  {
    nameOne: "Deborah",
    nameTwo: "Hannah",
    isTheSameName: false,
  },
  {
    nameOne: "Deborah",
    nameTwo: "Lily",
    isTheSameName: false,
  },
  {
    nameOne: "Kahija",
    nameTwo: "Kahika",
    isTheSameName: true,
  },
  {
    nameOne: "Kahija",
    nameTwo: "Kiernan",
    isTheSameName: false,
  },
  {
    nameOne: "Kahija",
    nameTwo: "Sckroyd",
    isTheSameName: false,
  },
  {
    nameOne: "Sckroyd",
    nameTwo: "Kiernan",
    isTheSameName: false,
  },
  {
    nameOne: "Backlund",
    nameTwo: "Backlund.",
    isTheSameName: true,
  },
  {
    nameOne: "Cooke",
    nameTwo: "Backlund",
    isTheSameName: false,
  },
  {
    nameOne: "Chan",
    nameTwo: "Eugenie",
    isTheSameName: false,
  },
  {
    nameOne: "Eugenie",
    nameTwo: "Joel",
    isTheSameName: false,
  },
  {
    nameOne: "Felicia",
    nameTwo: "Vinay",
    isTheSameName: false,
  },
  {
    nameOne: "Giorgio",
    nameTwo: "Rebecca",
    isTheSameName: false,
  },
  {
    nameOne: "Glenda",
    nameTwo: "Mark",
    isTheSameName: false,
  },
  {
    nameOne: "Glenda",
    nameTwo: "Vanessa",
    isTheSameName: false,
  },
  {
    nameOne: "Edwards",
    nameTwo: "Redman",
    isTheSameName: false,
  },
  {
    nameOne: "Hannah",
    nameTwo: "Lily",
    isTheSameName: false,
  },
  {
    nameOne: "Ng",
    nameTwo: "Rapana-jenkins",
    isTheSameName: false,
  },
  {
    nameOne: "Izaac",
    nameTwo: "Kimberly",
    isTheSameName: false,
  },
  {
    nameOne: "Jen",
    nameTwo: "Jenny",
    isTheSameName: true,
  },
  {
    nameOne: "Jerry",
    nameTwo: "Jo",
    isTheSameName: false,
  },
  {
    nameOne: "Huang",
    nameTwo: "White",
    isTheSameName: false,
  },
  {
    nameOne: "Joan",
    nameTwo: "Nathan",
    isTheSameName: false,
  },
  {
    nameOne: "Berrigan",
    nameTwo: "Crow",
    isTheSameName: false,
  },
  {
    nameOne: "Berrigan",
    nameTwo: "Secomb",
    isTheSameName: false,
  },
  {
    nameOne: "Berrigan",
    nameTwo: "Williams",
    isTheSameName: false,
  },
  {
    nameOne: "Crow",
    nameTwo: "Secomb",
    isTheSameName: false,
  },
  {
    nameOne: "Crow",
    nameTwo: "Williams",
    isTheSameName: false,
  },
  {
    nameOne: "Secomb",
    nameTwo: "Williams",
    isTheSameName: false,
  },
  {
    nameOne: "Tangira",
    nameTwo: "Scott",
    isTheSameName: false,
  },
  {
    nameOne: "Triggs",
    nameTwo: "Smith",
    isTheSameName: false,
  },
  {
    nameOne: "Katie",
    nameTwo: "Katoe",
    isTheSameName: true,
  },
  {
    nameOne: "Callcott",
    nameTwo: "Brinsden",
    isTheSameName: false,
  },
  {
    nameOne: "Callcott",
    nameTwo: "Gek",
    isTheSameName: false,
  },
  {
    nameOne: "Callcott",
    nameTwo: "Todd",
    isTheSameName: false,
  },
  {
    nameOne: "Gek",
    nameTwo: "Todd",
    isTheSameName: false,
  },
  {
    nameOne: "Kim",
    nameTwo: "Nick",
    isTheSameName: false,
  },
  {
    nameOne: "Leon",
    nameTwo: "Subria",
    isTheSameName: false,
  },
  {
    nameOne: "Liam",
    nameTwo: "Rachel",
    isTheSameName: false,
  },
  {
    nameOne: "Cawthorn",
    nameTwo: "Cawthorn 28th-1st november",
    isTheSameName: true,
  },
  {
    nameOne: "Cawthorn",
    nameTwo: "Colley",
    isTheSameName: false,
  },
  {
    nameOne: "Cawthorn",
    nameTwo: "Longmire",
    isTheSameName: false,
  },
  {
    nameOne: "Cawthorn",
    nameTwo: "Sapuppo",
    isTheSameName: false,
  },
  {
    nameOne: "Lisa",
    nameTwo: "Simon",
    isTheSameName: false,
  },
  {
    nameOne: "Cawthorn 7th-13th",
    nameTwo: "Hawthorne",
    isTheSameName: true,
  },
  {
    nameOne: "Cawthorn 7th-13th",
    nameTwo: "Cawthorn",
    isTheSameName: true,
  },
  {
    nameOne: "Cawthorn 7th-13th",
    nameTwo: "Colley",
    isTheSameName: false,
  },
  {
    nameOne: "Cawthorn 7th-13th",
    nameTwo: "Longmire",
    isTheSameName: false,
  },
  {
    nameOne: "Cawthorn 7th-13th",
    nameTwo: "Sapuppo",
    isTheSameName: false,
  },
  {
    nameOne: "Sapuppo",
    nameTwo: "Colley",
    isTheSameName: false,
  },
  {
    nameOne: "Sapuppo",
    nameTwo: "Longmire",
    isTheSameName: false,
  },
  {
    nameOne: "Anderson",
    nameTwo: "Andeson",
    isTheSameName: true,
  },
  {
    nameOne: "Mark",
    nameTwo: "Vanessa",
    isTheSameName: false,
  },
  {
    nameOne: "De loryn",
    nameTwo: "Deoryn",
    isTheSameName: true,
  },
  {
    nameOne: "Devadas",
    nameTwo: "De loryn",
    isTheSameName: false,
  },
  {
    nameOne: "Matt",
    nameTwo: "Matthew",
    isTheSameName: true,
  },
  {
    nameOne: "Mick",
    nameTwo: "Ruth",
    isTheSameName: false,
  },
  {
    nameOne: "George",
    nameTwo: "Senat",
    isTheSameName: false,
  },
  {
    nameOne: "Chee",
    nameTwo: "Mclean",
    isTheSameName: false,
  },
  {
    nameOne: "Chee",
    nameTwo: "White",
    isTheSameName: false,
  },
  {
    nameOne: "Mclean",
    nameTwo: "White",
    isTheSameName: false,
  },
  {
    nameOne: "Khiroya",
    nameTwo: "Rough",
    isTheSameName: false,
  },
  {
    nameOne: "Khiroya",
    nameTwo: "Todd",
    isTheSameName: false,
  },
  {
    nameOne: "Nick",
    nameTwo: "Sarah",
    isTheSameName: false,
  },
  {
    nameOne: "Rough",
    nameTwo: "Todd",
    isTheSameName: false,
  },
  {
    nameOne: "Nick",
    nameTwo: "Vicky",
    isTheSameName: false,
  },
  {
    nameOne: "Mcglone",
    nameTwo: "Mcglones",
    isTheSameName: true,
  },
  {
    nameOne: "Wyborn",
    nameTwo: "Mcglone",
    isTheSameName: false,
  },
  {
    nameOne: "Hiron",
    nameTwo: "Alder",
    isTheSameName: false,
  },
  {
    nameOne: "Popie",
    nameTwo: "Russell",
    isTheSameName: false,
  },
  {
    nameOne: "Carteldge",
    nameTwo: "Cartledge",
    isTheSameName: true,
  },
  {
    nameOne: "Carteldge",
    nameTwo: "Tani",
    isTheSameName: false,
  },
  {
    nameOne: "Carteldge",
    nameTwo: "Woods",
    isTheSameName: false,
  },
  {
    nameOne: "Glover",
    nameTwo: "Carteldge",
    isTheSameName: false,
  },
  {
    nameOne: "Glover",
    nameTwo: "Tani",
    isTheSameName: false,
  },
  {
    nameOne: "Glover",
    nameTwo: "Woods",
    isTheSameName: false,
  },
  {
    nameOne: "Tani",
    nameTwo: "Woods",
    isTheSameName: false,
  },
  {
    nameOne: "Ralfi",
    nameTwo: "Ralfy",
    isTheSameName: true,
  },
  {
    nameOne: "Buckle",
    nameTwo: "Rey",
    isTheSameName: false,
  },
  {
    nameOne: "Ribyn",
    nameTwo: "Robyn",
    isTheSameName: true,
  },
  {
    nameOne: "Rigby",
    nameTwo: "Ortiz",
    isTheSameName: false,
  },
  {
    nameOne: "Agius",
    nameTwo: "Beasant",
    isTheSameName: false,
  },
  {
    nameOne: "Carrasco",
    nameTwo: "Dwyer",
    isTheSameName: false,
  },
  {
    nameOne: "Carrasco",
    nameTwo: "Fagan",
    isTheSameName: false,
  },
  {
    nameOne: "Carrasco",
    nameTwo: "Trial",
    isTheSameName: false,
  },
  {
    nameOne: "Dwyer",
    nameTwo: "Fagan",
    isTheSameName: false,
  },
  {
    nameOne: "Dwyer",
    nameTwo: "Trial",
    isTheSameName: false,
  },
  {
    nameOne: "Fagan",
    nameTwo: "Trial",
    isTheSameName: false,
  },
  {
    nameOne: "Perumal",
    nameTwo: "Reid",
    isTheSameName: false,
  },
  {
    nameOne: "Hinchlidde",
    nameTwo: "Hinchliffe",
    isTheSameName: true,
  },
  {
    nameOne: "Sarag",
    nameTwo: "Sarah",
    isTheSameName: true,
  },
  {
    nameOne: "Christie",
    nameTwo: "Khiroya",
    isTheSameName: false,
  },
  {
    nameOne: "Christie",
    nameTwo: "Sparey",
    isTheSameName: false,
  },
  {
    nameOne: "Khiroya",
    nameTwo: "Sparey",
    isTheSameName: false,
  },
  {
    nameOne: "Serg",
    nameTwo: "Serge",
    isTheSameName: true,
  },
  {
    nameOne: "Thomas",
    nameTwo: "Thomas mathew",
    isTheSameName: false,
  },
  {
    nameOne: "Tabby",
    nameTwo: "Tabitha",
    isTheSameName: true,
  },
  {
    nameOne: "Halkiotis",
    nameTwo: "Woolaston",
    isTheSameName: false,
  },
  {
    nameOne: "Cartledge",
    nameTwo: "Meers",
    isTheSameName: false,
  },
  {
    nameOne: "Cawthorn 7th-13th",
    nameTwo: "Cawthorn 28th-1st november",
    isTheSameName: true,
  },
  {
    nameOne: "Christie",
    nameTwo: "Sibi thomas",
    isTheSameName: false,
  },
  {
    nameOne: "Colley",
    nameTwo: "Longmire",
    isTheSameName: false,
  },
  {
    nameOne: "Colley",
    nameTwo: "Cawthorn  30th-6thjuly",
    isTheSameName: false,
  },
  {
    nameOne: "Colley",
    nameTwo: "Cawthorn 4th-8th november",
    isTheSameName: false,
  },
  {
    nameOne: "Deanne",
    nameTwo: "Dave",
    isTheSameName: false,
  },
  {
    nameOne: "Deborah",
    nameTwo: "Dave",
    isTheSameName: false,
  },
  {
    nameOne: "Hannah",
    nameTwo: "Dave",
    isTheSameName: false,
  },
  {
    nameOne: "Lily",
    nameTwo: "Dave",
    isTheSameName: false,
  },
  {
    nameOne: "Felton",
    nameTwo: "Felton",
    isTheSameName: true,
  },
  {
    nameOne: "Serg",
    nameTwo: "Sege",
    isTheSameName: true,
  },
  {
    nameOne: "Matt",
    nameTwo: "Mat",
    isTheSameName: true,
  },
  {
    nameOne: "Kahija",
    nameTwo: "Ackroyd",
    isTheSameName: false,
  },
  {
    nameOne: "Kahika",
    nameTwo: "Meers",
    isTheSameName: false,
  },
  {
    nameOne: "Khiroya",
    nameTwo: "Sibi thomas",
    isTheSameName: false,
  },
  {
    nameOne: "Kiernan",
    nameTwo: "Ackroyd",
    isTheSameName: false,
  },
  {
    nameOne: "Joey",
    nameTwo: "Vasiti",
    isTheSameName: false,
  },
  {
    nameOne: "Alam",
    nameTwo: "Akan",
    isTheSameName: true,
  },
  {
    nameOne: "Longmire",
    nameTwo: "Cawthorn  30th-6thjuly",
    isTheSameName: false,
  },
  {
    nameOne: "Longmire",
    nameTwo: "Cawthorn 4th-8th november",
    isTheSameName: false,
  },
  {
    nameOne: "Moore",
    nameTwo: "Cawthorn  30th-6thjuly",
    isTheSameName: false,
  },
  {
    nameOne: "Moore",
    nameTwo: "Cawthorn 4th-8th november",
    isTheSameName: false,
  },
  {
    nameOne: "Sapuppo",
    nameTwo: "Cawthorn  30th-6thjuly",
    isTheSameName: false,
  },
  {
    nameOne: "Sapuppo",
    nameTwo: "Cawthorn 4th-8th november",
    isTheSameName: false,
  },
  {
    nameOne: "Sckroyd",
    nameTwo: "Ackroyd",
    isTheSameName: true,
  },
  {
    nameOne: "Cawthorn 4th-8th november",
    nameTwo: "Cawthorn 7th-13th",
    isTheSameName: true,
  },
  {
    nameOne: "Cawthorn 4th-8th november",
    nameTwo: "Cawthorn  30th-6thjuly",
    isTheSameName: true,
  },
  {
    nameOne: "Cawthorn 4th-8th november",
    nameTwo: "Cawthorn",
    isTheSameName: true,
  },
  {
    nameOne: "Cawthorn 4th-8th november",
    nameTwo: "Cawthorn 28th-1st november",
    isTheSameName: true,
  },
  {
    nameOne: "Cawthorn  30th-6thjuly",
    nameTwo: "Cawthorn 7th-13th",
    isTheSameName: true,
  },
  {
    nameOne: "Cawthorn  30th-6thjuly",
    nameTwo: "Cawthorn",
    isTheSameName: true,
  },
  {
    nameOne: "Colley",
    nameTwo: "Cawthorn 28th-1st november",
    isTheSameName: false,
  },
  {
    nameOne: "Longmire",
    nameTwo: "Cawthorn 28th-1st november",
    isTheSameName: false,
  },
  {
    nameOne: "Sapuppo",
    nameTwo: "Cawthorn 28th-1st november",
    isTheSameName: false,
  },
  {
    nameOne: "Cawthorn 28th-1st november",
    nameTwo: "Cawthorn  30th-6thjuly",
    isTheSameName: true,
  },
  {
    nameOne: "Cawthorn 28th-1st november",
    nameTwo: "Hawthorne",
    isTheSameName: true,
  },
  {
    nameOne: "",
    nameTwo: "",
    isTheSameName: false,
  },
  {
    nameOne: "janet and wayne",
    nameTwo: "kylie",
    isTheSameName: false,
  },
  {
    nameOne: "thomas",
    nameTwo: "thomas",
    isTheSameName: true,
  },
  {
    nameOne: "barry",
    nameTwo: "lee",
    isTheSameName: false,
  },
  {
    nameOne: "barry",
    nameTwo: "barry",
    isTheSameName: true,
  },
  {
    nameOne: "betham",
    nameTwo: "riordan",
    isTheSameName: false,
  },
  {
    nameOne: "brinaden",
    nameTwo: "gek",
    isTheSameName: false,
  },
  {
    nameOne: "brinaden",
    nameTwo: "callcott",
    isTheSameName: false,
  },
  {
    nameOne: "brinaden",
    nameTwo: "baxter",
    isTheSameName: false,
  },
  {
    nameOne: "brinsde",
    nameTwo: "gek",
    isTheSameName: false,
  },
  {
    nameOne: "brinsde",
    nameTwo: "callcott",
    isTheSameName: false,
  },
  {
    nameOne: "brinsde",
    nameTwo: "baxter",
    isTheSameName: false,
  },
  {
    nameOne: "brinsden",
    nameTwo: "baxter",
    isTheSameName: false,
  },
  {
    nameOne: "allan",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "brow",
    nameTwo: "sancho",
    isTheSameName: false,
  },
  {
    nameOne: "brown",
    nameTwo: "sancho",
    isTheSameName: false,
  },
  {
    nameOne: "bunn",
    nameTwo: "stanmore",
    isTheSameName: false,
  },
  {
    nameOne: "ban",
    nameTwo: "cherie",
    isTheSameName: false,
  },
  {
    nameOne: "peter",
    nameTwo: "alyce",
    isTheSameName: false,
  },
  {
    nameOne: "carole",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "katie",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "lorene",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "louis",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "renee",
    nameTwo: "isaac",
    isTheSameName: false,
  },
  {
    nameOne: "jono",
    nameTwo: "kmy",
    isTheSameName: false,
  },
  {
    nameOne: "jono",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "dunn",
    nameTwo: "sangster",
    isTheSameName: false,
  },
  {
    nameOne: "edwards",
    nameTwo: "iqbal",
    isTheSameName: false,
  },
  {
    nameOne: "emerton",
    nameTwo: "andrew",
    isTheSameName: false,
  },
  {
    nameOne: "kelly",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "manfred",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "celeste",
    nameTwo: "alyce",
    isTheSameName: false,
  },
  {
    nameOne: "feebrey",
    nameTwo: "riordan",
    isTheSameName: false,
  },
  {
    nameOne: "joel",
    nameTwo: "giorgio",
    isTheSameName: false,
  },
  {
    nameOne: "joel",
    nameTwo: "rebecca",
    isTheSameName: false,
  },
  {
    nameOne: "feebrey",
    nameTwo: "pauls",
    isTheSameName: false,
  },
  {
    nameOne: "joel",
    nameTwo: "alyce",
    isTheSameName: false,
  },
  {
    nameOne: "felton",
    nameTwo: "wyborn",
    isTheSameName: false,
  },
  {
    nameOne: "felton",
    nameTwo: "mcglone",
    isTheSameName: false,
  },
  {
    nameOne: "nick",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "field",
    nameTwo: "khiroya",
    isTheSameName: false,
  },
  {
    nameOne: "hilton & nicky",
    nameTwo: "liesl",
    isTheSameName: false,
  },
  {
    nameOne: "field",
    nameTwo: "todd",
    isTheSameName: false,
  },
  {
    nameOne: "field",
    nameTwo: "felton",
    isTheSameName: false,
  },
  {
    nameOne: "foster",
    nameTwo: "foster",
    isTheSameName: true,
  },
  {
    nameOne: "foster",
    nameTwo: "overton",
    isTheSameName: false,
  },
  {
    nameOne: "stephen",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "garratt",
    nameTwo: "garratt",
    isTheSameName: true,
  },
  {
    nameOne: "glass",
    nameTwo: "eberle",
    isTheSameName: false,
  },
  {
    nameOne: "goode",
    nameTwo: "shepherd",
    isTheSameName: false,
  },
  {
    nameOne: "serge",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "serge",
    nameTwo: "alyce",
    isTheSameName: false,
  },
  {
    nameOne: "hoare",
    nameTwo: "hoare",
    isTheSameName: true,
  },
  {
    nameOne: "iqbal",
    nameTwo: "glauser",
    isTheSameName: false,
  },
  {
    nameOne: "iqbal",
    nameTwo: "harman",
    isTheSameName: false,
  },
  {
    nameOne: "jarvis",
    nameTwo: "stahorn",
    isTheSameName: false,
  },
  {
    nameOne: "johnson",
    nameTwo: "sugunarajan",
    isTheSameName: false,
  },
  {
    nameOne: "johnson",
    nameTwo: "cunningham",
    isTheSameName: false,
  },
  {
    nameOne: "jones",
    nameTwo: "wood",
    isTheSameName: false,
  },
  {
    nameOne: "jones",
    nameTwo: "jarvis",
    isTheSameName: false,
  },
  {
    nameOne: "debise",
    nameTwo: "lauren",
    isTheSameName: false,
  },
  {
    nameOne: "dk",
    nameTwo: "lauren",
    isTheSameName: false,
  },
  {
    nameOne: "dk",
    nameTwo: "leah",
    isTheSameName: false,
  },
  {
    nameOne: "keene",
    nameTwo: "cain",
    isTheSameName: false,
  },
  {
    nameOne: "paul",
    nameTwo: "alyce",
    isTheSameName: false,
  },
  {
    nameOne: "wendy",
    nameTwo: "alyce",
    isTheSameName: false,
  },
  {
    nameOne: "wendy",
    nameTwo: "elly",
    isTheSameName: false,
  },
  {
    nameOne: "kia",
    nameTwo: "chong",
    isTheSameName: false,
  },
  {
    nameOne: "knowles",
    nameTwo: "overton",
    isTheSameName: false,
  },
  {
    nameOne: "stephanie",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "knowles",
    nameTwo: "koslan-knowles",
    isTheSameName: true,
  },
  {
    nameOne: "lauren",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "sharon",
    nameTwo: "isaac",
    isTheSameName: false,
  },
  {
    nameOne: "sharon",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "kong",
    nameTwo: "tsang",
    isTheSameName: false,
  },
  {
    nameOne: "evelyn",
    nameTwo: "isaac",
    isTheSameName: false,
  },
  {
    nameOne: "evelyn",
    nameTwo: "katie",
    isTheSameName: false,
  },
  {
    nameOne: "kong",
    nameTwo: "brittain",
    isTheSameName: false,
  },
  {
    nameOne: "evelyn",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "koslan-knowles",
    nameTwo: "overton",
    isTheSameName: false,
  },
  {
    nameOne: "koslan-knowles",
    nameTwo: "koslan-knowles",
    isTheSameName: true,
  },
  {
    nameOne: "lahika",
    nameTwo: "sckroyd",
    isTheSameName: false,
  },
  {
    nameOne: "kieran",
    nameTwo: "alyce",
    isTheSameName: false,
  },
  {
    nameOne: "katie",
    nameTwo: "isaac",
    isTheSameName: false,
  },
  {
    nameOne: "leonard",
    nameTwo: "thomas",
    isTheSameName: false,
  },
  {
    nameOne: "leonard",
    nameTwo: "proud",
    isTheSameName: false,
  },
  {
    nameOne: "leonard",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "tracy",
    nameTwo: "alyce",
    isTheSameName: false,
  },
  {
    nameOne: "lindley",
    nameTwo: "shepherd",
    isTheSameName: false,
  },
  {
    nameOne: "livingstone",
    nameTwo: "hollands",
    isTheSameName: false,
  },
  {
    nameOne: "livingstone",
    nameTwo: "orr",
    isTheSameName: false,
  },
  {
    nameOne: "melinda",
    nameTwo: "isaac",
    isTheSameName: false,
  },
  {
    nameOne: "melinda",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "gl;enys",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "glenys",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "glwenys",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "glenyslocke",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "loi",
    nameTwo: "stanmore",
    isTheSameName: false,
  },
  {
    nameOne: "loi",
    nameTwo: "rigby",
    isTheSameName: false,
  },
  {
    nameOne: "loi",
    nameTwo: "loi",
    isTheSameName: true,
  },
  {
    nameOne: "helga",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "helga",
    nameTwo: "alyce",
    isTheSameName: false,
  },
  {
    nameOne: "lyon",
    nameTwo: "lyon",
    isTheSameName: true,
  },
  {
    nameOne: "lyndelle",
    nameTwo: "caitlin",
    isTheSameName: false,
  },
  {
    nameOne: "macdowall",
    nameTwo: "smart",
    isTheSameName: false,
  },
  {
    nameOne: "macdowall",
    nameTwo: "brittain",
    isTheSameName: false,
  },
  {
    nameOne: "lyndelle",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "olivia",
    nameTwo: "isaac",
    isTheSameName: false,
  },
  {
    nameOne: "mcelrea",
    nameTwo: "moss",
    isTheSameName: false,
  },
  {
    nameOne: "medwin",
    nameTwo: "whincop",
    isTheSameName: false,
  },
  {
    nameOne: "medwin",
    nameTwo: "tunha",
    isTheSameName: false,
  },
  {
    nameOne: "meers",
    nameTwo: "van heel",
    isTheSameName: false,
  },
  {
    nameOne: "meers",
    nameTwo: "warner",
    isTheSameName: false,
  },
  {
    nameOne: "meers",
    nameTwo: "vanheel",
    isTheSameName: false,
  },
  {
    nameOne: "moore",
    nameTwo: "eberle",
    isTheSameName: false,
  },
  {
    nameOne: "lisa",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "lisa",
    nameTwo: "gregory",
    isTheSameName: false,
  },
  {
    nameOne: "alexandra",
    nameTwo: "amanda",
    isTheSameName: false,
  },
  {
    nameOne: "neville",
    nameTwo: "alyce",
    isTheSameName: false,
  },
  {
    nameOne: "ameshri",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "amy",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "pauline",
    nameTwo: "riley",
    isTheSameName: false,
  },
  {
    nameOne: "pauline",
    nameTwo: "peter",
    isTheSameName: false,
  },
  {
    nameOne: "pauline",
    nameTwo: "eve",
    isTheSameName: false,
  },
  {
    nameOne: "pauline",
    nameTwo: "chris",
    isTheSameName: false,
  },
  {
    nameOne: "pauline",
    nameTwo: "joan",
    isTheSameName: false,
  },
  {
    nameOne: "pauline",
    nameTwo: "lisa",
    isTheSameName: false,
  },
  {
    nameOne: "pauline",
    nameTwo: "anna",
    isTheSameName: false,
  },
  {
    nameOne: "pauline",
    nameTwo: "kate",
    isTheSameName: false,
  },
  {
    nameOne: "pauline",
    nameTwo: "katie",
    isTheSameName: false,
  },
  {
    nameOne: "pauline",
    nameTwo: "kristen",
    isTheSameName: false,
  },
  {
    nameOne: "pauline",
    nameTwo: "adele",
    isTheSameName: false,
  },
  {
    nameOne: "pauline",
    nameTwo: "adam",
    isTheSameName: false,
  },
  {
    nameOne: "pauline",
    nameTwo: "renee",
    isTheSameName: false,
  },
  {
    nameOne: "pauline",
    nameTwo: "olivia",
    isTheSameName: false,
  },
  {
    nameOne: "pauline",
    nameTwo: "melinda",
    isTheSameName: false,
  },
  {
    nameOne: "pauline",
    nameTwo: "benjamin",
    isTheSameName: false,
  },
  {
    nameOne: "pauline",
    nameTwo: "sharon",
    isTheSameName: false,
  },
  {
    nameOne: "ng",
    nameTwo: "kellaway",
    isTheSameName: false,
  },
  {
    nameOne: "pauline",
    nameTwo: "julie",
    isTheSameName: false,
  },
  {
    nameOne: "pauline",
    nameTwo: "evelyn",
    isTheSameName: false,
  },
  {
    nameOne: "pauline",
    nameTwo: "jacinda",
    isTheSameName: false,
  },
  {
    nameOne: "ortiz",
    nameTwo: "stanmore",
    isTheSameName: false,
  },
  {
    nameOne: "ortiz",
    nameTwo: "loi",
    isTheSameName: false,
  },
  {
    nameOne: "ortiz",
    nameTwo: "o",
    isTheSameName: true,
  },
  {
    nameOne: "pauls",
    nameTwo: "riordan",
    isTheSameName: false,
  },
  {
    nameOne: "pauls",
    nameTwo: "chan",
    isTheSameName: false,
  },
  {
    nameOne: "portwin",
    nameTwo: "carrasco",
    isTheSameName: false,
  },
  {
    nameOne: "rapana",
    nameTwo: "renae",
    isTheSameName: false,
  },
  {
    nameOne: "renae",
    nameTwo: "isaac",
    isTheSameName: false,
  },
  {
    nameOne: "mike",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "saldana",
    nameTwo: "tsang",
    isTheSameName: false,
  },
  {
    nameOne: "sangster",
    nameTwo: "jarvis",
    isTheSameName: false,
  },
  {
    nameOne: "benjamin",
    nameTwo: "isaac",
    isTheSameName: false,
  },
  {
    nameOne: "sangster",
    nameTwo: "burns",
    isTheSameName: false,
  },
  {
    nameOne: "jacinda",
    nameTwo: "isaac",
    isTheSameName: false,
  },
  {
    nameOne: "rocky",
    nameTwo: "alyce",
    isTheSameName: false,
  },
  {
    nameOne: "terry",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "shapcott",
    nameTwo: "damianopoulos",
    isTheSameName: false,
  },
  {
    nameOne: "shapcott",
    nameTwo: "triggs",
    isTheSameName: false,
  },
  {
    nameOne: "shapcott",
    nameTwo: "smith",
    isTheSameName: false,
  },
  {
    nameOne: "shapcott",
    nameTwo: "shapcott",
    isTheSameName: true,
  },
  {
    nameOne: "mark and karen",
    nameTwo: "mark & karen",
    isTheSameName: true,
  },
  {
    nameOne: "smith",
    nameTwo: "smith",
    isTheSameName: true,
  },
  {
    nameOne: "jason",
    nameTwo: "ric",
    isTheSameName: false,
  },
  {
    nameOne: "jason",
    nameTwo: "vanessa",
    isTheSameName: false,
  },
  {
    nameOne: "jason",
    nameTwo: "gavin",
    isTheSameName: false,
  },
  {
    nameOne: "jason",
    nameTwo: "michelle",
    isTheSameName: false,
  },
  {
    nameOne: "jason",
    nameTwo: "amy",
    isTheSameName: false,
  },
  {
    nameOne: "jason",
    nameTwo: "hannah",
    isTheSameName: false,
  },
  {
    nameOne: "jason",
    nameTwo: "cindy",
    isTheSameName: false,
  },
  {
    nameOne: "jason",
    nameTwo: "laura",
    isTheSameName: false,
  },
  {
    nameOne: "jason",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "jason",
    nameTwo: "mark",
    isTheSameName: false,
  },
  {
    nameOne: "so",
    nameTwo: "so",
    isTheSameName: true,
  },
  {
    nameOne: "stanmore",
    nameTwo: "stanmore",
    isTheSameName: true,
  },
  {
    nameOne: "fay",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "stolar",
    nameTwo: "stolar",
    isTheSameName: true,
  },
  {
    nameOne: "sugunarajan",
    nameTwo: "edwards",
    isTheSameName: false,
  },
  {
    nameOne: "tailby",
    nameTwo: "mcghie",
    isTheSameName: false,
  },
  {
    nameOne: "wayne and janet",
    nameTwo: "kylie",
    isTheSameName: false,
  },
  {
    nameOne: "tinker",
    nameTwo: "wood",
    isTheSameName: false,
  },
  {
    nameOne: "tinker",
    nameTwo: "jarvis",
    isTheSameName: false,
  },
  {
    nameOne: "junior",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "ross",
    nameTwo: "alyce",
    isTheSameName: false,
  },
  {
    nameOne: "adele",
    nameTwo: "isaac",
    isTheSameName: false,
  },
  {
    nameOne: "were",
    nameTwo: "webb",
    isTheSameName: false,
  },
  {
    nameOne: "were",
    nameTwo: "stanmore",
    isTheSameName: false,
  },
  {
    nameOne: "were",
    nameTwo: "were",
    isTheSameName: true,
  },
  {
    nameOne: "georgia",
    nameTwo: "rob",
    isTheSameName: false,
  },
  {
    nameOne: "wood",
    nameTwo: "stahorn",
    isTheSameName: false,
  },
  {
    nameOne: "marty",
    nameTwo: "bec",
    isTheSameName: false,
  },
  {
    nameOne: "maureen",
    nameTwo: "bec",
    isTheSameName: false,
  },
  {
    nameOne: "martin",
    nameTwo: "bec",
    isTheSameName: false,
  },
  {
    nameOne: "maudie",
    nameTwo: "bec",
    isTheSameName: false,
  },
  {
    nameOne: "maudie",
    nameTwo: "marty",
    isTheSameName: false,
  },
  {
    nameOne: "benn",
    nameTwo: "benn",
    isTheSameName: true,
  },
  {
    nameOne: "smith mon)",
    nameTwo: "damianopoulos",
    isTheSameName: false,
  },
  {
    nameOne: "smith mon)",
    nameTwo: "triggs",
    isTheSameName: false,
  },
  {
    nameOne: "gee",
    nameTwo: "gee",
    isTheSameName: true,
  },
  {
    nameOne: "koblischk",
    nameTwo: "kahika",
    isTheSameName: false,
  },
  {
    nameOne: "loi",
    nameTwo: "bunn",
    isTheSameName: false,
  },
  {
    nameOne: "loi",
    nameTwo: "were",
    isTheSameName: false,
  },
  {
    nameOne: "bsrry",
    nameTwo: "lee",
    isTheSameName: false,
  },
  {
    nameOne: "benjamin",
    nameTwo: "cherie",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "damianopoulos",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "mutambiranwa",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "foster",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "austin",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "dunn",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "van heel",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "bodnar",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "kahika",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "bognar",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "beasant",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "mary",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "preece",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "gray",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "chong",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "palit",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "aghajanian",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "napier",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "babio",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "cunningham",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "rey",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "witham",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "wood",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "hoffmann",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "burns",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "agius",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "southcombe",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "furneaux",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "moss",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "medwin",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "dwyer",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "little",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "woodward",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "benn",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "whincop",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "renae",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "farrow",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "tinker",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "stanmore",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "devadas",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "buckle",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "nicole",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "triggs",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "ander",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "rigby",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "baxter",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "mcdonnell",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "de loryn",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "jones",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "de smit",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "sparey",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "tani",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "groenestyn",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "barker",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "simmons",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "lorking",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "proud",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "mcaulay",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "woodford",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "hagenaar",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "whitworth",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "garratt",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "bunn",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "tunha",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "smith",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "teuben",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "thompson",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "widi",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "deng",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "rodgers - falk",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "khiroya",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "shepherd",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "christie",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "were",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "warner",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "hurlock",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "ram",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "vanheel",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "montarulo",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "saeli",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "deevy",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "sutton",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "loi",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "glover",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "lawrence",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "hodge",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "meers",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "martinez",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "shapcott",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "o",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "hawkins",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "liew",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "sikler",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "huddleston",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "betham",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "watkins",
    isTheSameName: false,
  },
  {
    nameOne: "r",
    nameTwo: "alyce",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "sibi thomas",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "anderson",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "sayce",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "scott",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "parker",
    isTheSameName: false,
  },
  {
    nameOne: "wakeley",
    nameTwo: "lilley",
    isTheSameName: false,
  },
  {
    nameOne: "ro",
    nameTwo: "alyce",
    isTheSameName: false,
  },
  {
    nameOne: "wood",
    nameTwo: "wood",
    isTheSameName: true,
  },
  {
    nameOne: "marty",
    nameTwo: "rebecca",
    isTheSameName: false,
  },
  {
    nameOne: "maureen",
    nameTwo: "rebecca",
    isTheSameName: false,
  },
  {
    nameOne: "marty & maudie",
    nameTwo: "rebecca",
    isTheSameName: false,
  },
  {
    nameOne: "maudie",
    nameTwo: "rebecca",
    isTheSameName: false,
  },
  {
    nameOne: "martin",
    nameTwo: "rebecca",
    isTheSameName: false,
  },
];

export const numberOfTotalHours = (
  reportDatabase: ReportData[],
  campusId: string,
  year: string
) => {
  let totalNumberOfHours = 0;
  reportDatabase.forEach((report) => {
    //get year string from report.reportPeriodDate
    const reportYear = new Date(report.reportPeriodDate)
      .getFullYear()
      .toString();

    if (report.teamId === campusId && reportYear === year) {
      totalNumberOfHours += Number(report.crisisHours);
      totalNumberOfHours += Number(report.relationshipHours);
      totalNumberOfHours += Number(report.lifeSkillsHours);
      totalNumberOfHours += Number(report.traumaHours);
      totalNumberOfHours += Number(report.addNeedsHours);
      totalNumberOfHours += Number(report.healthHours);
      totalNumberOfHours += Number(report.mentalHealthHours);
    }
  });
  let finalTotalNumberOfHours = totalNumberOfHours.toFixed(2);
  console.log(finalTotalNumberOfHours);
};
/* export const reformatOldData = (reportData: ReportData[]) => {
  const newReportDatabase: ReportData[] = [];
  reportData.forEach((report) => {
    const newRepport = {
      ...report,
      reportPeriodDate: new Date(report.reportPeriodDate).toString(),
      lastEditDate: new Date().toString(),
      crisisWrittenHours: parseFloat(
        Number(report.crisisWrittenHours).toFixed(2)
      ),
      crisisInPersonHours: parseFloat(
        Number(report.crisisInPersonHours).toFixed(2)
      ),
      complaintHours: parseFloat(Number(report.complaintHours).toFixed(2)),
      adminhours: parseFloat(Number(report.adminHours).toFixed(2)),
      meetingsHours: parseFloat(Number(report.meetingsHours).toFixed(2)),
      relationshipWrittenHours: parseFloat(
        Number(report.relationshipWrittenHours).toFixed(2)
      ),
      relationshipInPersonHours: parseFloat(
        Number(report.relationshipInPersonHours).toFixed(2)
      ),
      lifeSkillsWrittenHours: parseFloat(
        Number(report.lifeSkillsWrittenHours).toFixed(2)
      ),
      lifeSkillsInPersonHours: parseFloat(
        Number(report.lifeSkillsInPersonHours).toFixed(2)
      ),
      traumaWrittenHours: parseFloat(
        Number(report.traumaWrittenHours).toFixed(2)
      ),
      traumaInPersonHours: parseFloat(
        Number(report.traumaInPersonHours).toFixed(2)
      ),
      addNeedsWrittenHours: parseFloat(
        Number(report.addNeedsWrittenHours).toFixed(2)
      ),
      addNeedsInPersonHours: parseFloat(
        Number(report.addNeedsInPersonHours).toFixed(2)
      ),
      griefLossWrittenHours: parseFloat(
        Number(report.griefLossWrittenHours).toFixed(2)
      ),
      griefLossInPersonHours: parseFloat(
        Number(report.griefLossInPersonHours).toFixed(2)
      ),
      healthWrittenHours: parseFloat(
        Number(report.healthWrittenHours).toFixed(2)
      ),
      healthInPersonHours: parseFloat(
        Number(report.healthInPersonHours).toFixed(2)
      ),
      mentalHealthWrittenHours: parseFloat(
        Number(report.mentalHealthWrittenHours).toFixed(2)
      ),
      mentalHealthInPersonHours: parseFloat(
        Number(report.mentalHealthInPersonHours).toFixed(2)
      ),
      totalPastoralHours: parseFloat(
        Number(report.totalPastoralHours).toFixed(2)
      ),
      DFVIncidents: parseFloat(Number(report.DFVIncidents).toFixed(2)),
      covidCases: parseFloat(Number(report.covidCases).toFixed(2)),
      covidDeaths: parseFloat(Number(report.covidDeaths).toFixed(2)),
      emergencyReliefHampersNumbers: parseFloat(
        Number(report.emergencyReliefHampersNumbers).toFixed(2)
      ),
      employmentReceived: parseFloat(
        Number(report.employmentReceived).toFixed(2)
      ),
      funeralsAttended: parseFloat(Number(report.funeralsAttended).toFixed(2)),
      lostJobs: parseFloat(Number(report.lostJobs).toFixed(2)),
      funeralsConducted: parseFloat(
        Number(report.funeralsConducted).toFixed(2)
      ),
      giftsFlowers: parseFloat(Number(report.giftsFlowers).toFixed(2)),
      hospitalVisits: parseFloat(Number(report.hospitalVisits).toFixed(2)),
      inBetweenJobsConnections: parseFloat(
        Number(report.inBetweenJobsConnections).toFixed(2)
      ),
      meals: parseFloat(Number(report.meals).toFixed(2)),
      medicalProffesionalSupportGroupStories: parseFloat(
        Number(report.medicalProffesionalSupportGroupStories).toFixed(2)
      ),
      medicalProffesionalsSupportGroupConnections: parseFloat(
        Number(report.medicalProffesionalsSupportGroupConnections).toFixed(2)
      ),
      kiloOfKindnessBags: parseFloat(
        Number(report.kiloOfKindnessBags).toFixed(2)
      ),
      nonSuicidalSelfInjury: parseFloat(
        Number(report.nonSuicidalSelfInjury).toFixed(2)
      ),
      pornAddictionHours: parseFloat(
        Number(report.pornAddictionHours).toFixed(2)
      ),
      prepAndEnrichAppointments: parseFloat(
        Number(report.prepAndEnrichAppointments).toFixed(2)
      ),
      professionalDevelopmentHours: parseFloat(
        Number(report.professionalDevelopmentHours).toFixed(2)
      ),
      suicidalIdeation: parseFloat(Number(report.suicidalIdeation).toFixed(2)),
      weedingsConducted: parseFloat(
        Number(report.weedingsConducted).toFixed(2)
      ),
      firstName:
        report.firstName.charAt(0).toUpperCase() +
        report.firstName.slice(1).toLowerCase(),
      lastName:
        report.lastName.charAt(0).toUpperCase() +
        report.lastName.slice(1).toLowerCase(),
      email: report.email.toLowerCase(),
    };
    newReportDatabase.push(newRepport);
  });
  console.log(newReportDatabase);
}; */

export const checkTwoDatabaseHaveSameKeys = (
  dataBase1: ReportData[],
  dataBase2: ReportData[]
) => {
  const listOfKeysInReportDatabase = Object.keys(dataBase1[0]);
  const listOfKeysInReportDatabaseOld = Object.keys(dataBase2[0]);
  listOfKeysInReportDatabaseOld.forEach((key) => {
    if (!listOfKeysInReportDatabase.includes(key)) {
      console.log(key);
    } else {
      console.log("All Good");
    }
  });
};

export const checkReportsWithDatesInNames = (
  reports: ReportData[]
): ReportData[] => {
  const listOfReports: ReportData[] = [];

  reports.forEach((report) => {
    if (
      report.firstName.includes("(") ||
      report.firstName.includes(")") ||
      report.lastName.includes("(") ||
      report.lastName.includes(")")
    ) {
      listOfReports.push(report);
    }
  });

  console.log(listOfReports);
  return listOfReports;
};

export const attributeUserIdToReports = (
  reportDatabase: ReportData[],
  usersDatabase: UserData[]
): ReportData[] => {
  const newUserDatabase: UserData[] = usersDatabase;
  const newReportDatabase: ReportData[] = [];

  console.log(`User Database before any changes`);
  console.log(newUserDatabase);

  //Go over the report database and check if the email in the report matches existing user
  let reportNumber = 0;

  reportDatabase.forEach((report) => {
    let existingUser = searchUser(
      report.email,
      report.firstName,
      report.lastName,
      newUserDatabase
    );

    reportNumber += 1;
    console.log(reportNumber);
    console.log(existingUser);
    //if no existing user...
    if (!existingUser) {
      /*       console.log(`New User ${report.firstName} ${report.lastName}`) */
      const newUserId = createNewUserId(newUserDatabase);
      //create new user object
      const newUser = {
        userId: newUserId,
        firstName:
          report.firstName.charAt(0).toUpperCase() +
          report.firstName.slice(1).toLowerCase(),
        lastName:
          report.lastName.charAt(0).toUpperCase() +
          report.lastName.slice(1).toLowerCase(),
        email: [report.email.toLowerCase()],
        PCRoles: [
          {
            role: "volunteer" as const,
            teamId: report.teamId.toUpperCase(),
          },
        ],
      };
      //push this new user to the user Database
      /* console.log(`pushing new user`) */
      newUserDatabase.push(newUser);
      //and update report entry with the new userid
      const newReport = {
        ...report,
        reportPeriodDate: new Date(report.reportPeriodDate).toString(),
        lastEditDate: new Date().toString(),
        userId: newUser.userId,
      };
      newReportDatabase.push(newReport);
    }
    //if existing user the report already has a userId so we just
    // push it as is to the new report database
    else {
      const newReport = {
        ...report,
        reportPeriodDate: new Date(report.reportPeriodDate).toString(),
        lastEditDate: new Date().toString(),
        userId: existingUser.userId,
      };
      newReportDatabase.push(newReport);
    }
  });

  const cleanedUpNewUserDatabase = cleanupDatabase(newUserDatabase);
  console.log("NewUserDataBase");
  console.log(cleanedUpNewUserDatabase);
  console.log("NewReportDataBase");
  console.log(newReportDatabase);
  return newReportDatabase;
};

export const listAllCampusesInReportDatabase = (
  reportData: ReportData[]
): void => {
  const listOfCampuses: string[] = [];

  reportData.forEach((report) => {
    if (!listOfCampuses.includes(report.location)) {
      listOfCampuses.push(report.location);
    }
  });
  listOfCampuses.sort((a, b) => a.localeCompare(b));

  console.log(listOfCampuses);
};

export const changeLocationNameSunShine = (reportData: ReportData[]) => {
  const newReportData: ReportData[] = reportData;

  reportData.forEach((report) => {
    if (report.location === "Link - Ku-Ring-Gai") {
      report.location = "Sydney - Ku-Ring-Gai";
    }
    if (report.location === "Ku-Ring-Gai") {
      report.location = "Sydney - Ku-Ring-Gai";
    }
    if (report.location === "Link - Launceston") {
      report.location = "Launceston";
    }
    if (report.location === "Link - Sunshine Coast - South") {
      report.location = "Sunshine Coast - South";
    }
  });

  console.log(newReportData);
};

export const changeLocationId = (
  reportData: ReportData[],
  orgTreeDatabase: OrgTreeItem
) => {
  const newReportData: ReportData[] = reportData;

  const getIdByLabel = (
    label: string,
    node: OrgTreeItem
  ): string | undefined => {
    if (node.label === label) {
      return node.teamId;
    }

    if (node.children) {
      for (let child of node.children) {
        const id = getIdByLabel(label, child);
        if (id) {
          return id;
        }
      }
    } else {
    }
  };

  newReportData.forEach((report) => {
    const campusId = getIdByLabel(report.location, orgTreeDatabase);
    if (campusId) {
      report.teamId = campusId;
    } else {
      console.log(`No label found for Report`);
      console.log(report);
    }
  });

  console.log(newReportData);
};

export const checkUsersWithLessThanTwoReports = (
  usersDatabase: UserData[],
  reportDatabase: ReportData[]
) => {
  const usersWithLessThanTwoReports: UserData[] = [];
  usersDatabase.forEach((user) => {
    const numberOfReports = reportDatabase.filter(
      (report) =>
        report.firstName.trim() === user.firstName.trim() &&
        report.lastName.trim() === user.lastName.trim()
    );
    if (numberOfReports.length <= 2) {
      usersWithLessThanTwoReports.push(user);
    }
  });
  console.log(usersDatabase.length);
};

export const cleanupSpacesInReportEntries = (reportDatabase: ReportData[]) => {
  const newReportDatabase = reportDatabase;
  newReportDatabase.forEach((report) => {
    report.firstName = report.firstName.trim();
    report.lastName = report.lastName.trim();
    report.email = report.email.trim();
  });
  console.log(newReportDatabase);
};

export const changeReportKeyName = (reportDatabase: ReportData[]) => {
  const newReportDatabase = reportDatabase;
  newReportDatabase.forEach((report) => {
    /*     report.pornAddictionHours = report.pornAddiction;
    delete report.pornAddiction;
    report.adminHours = report.adminhours;
    delete report.adminhours; */
  });
  console.log(newReportDatabase);
};

export function generateRandomString() {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let result = "";
  for (let i = 0; i < 30; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

export const emptyReportNoOptional: ReportData = {
  firstName: "",
  lastName: "",
  email: "",
  location: "",
  teamId: "",
  involvement: "",
  totalInPersonHours: 0,
  totalPastoralHours: 0,
  reportPeriodDate: "",
  lastEditDate: "",
  reportId: "",
  userId: "",
  bucketId: "",
};

export const attributeUserIdToReport = (
  report: ReportData,
  usersDatabase: UserData[]
): ReportData => {
  const newUserDatabase: UserData[] = usersDatabase;

  let existingUser = searchUser(
    report.email,
    report.firstName,
    report.lastName,
    newUserDatabase
  );

  //if no existing user...
  if (!existingUser) {
    return report;
  } else {
    const newReport = {
      ...report,
      userId: existingUser.userId,
    };
    return newReport;
  }
};

export function capitalizeFirstLetterOfEveryWord(str: string): string {
  return str
    .trim()
    .split(" ") // Split the string into words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize the first letter of each word
    .join(" "); // Join the words back together
}

export function getReportsForIndividualReporter(user: UserData) {
  const teamIds = user.PCRoles.map((role) => role.teamId);
}

export const getDashBoardData = (
  dates: Date[],
  reportData: ReportData[]
): DashboardDataType => {
  const dashboardData: DashboardDataType = {
    adminAndMeetingHours: 0,
    personalDevelopment: 0,
    totalInPersonHours: 0,
    totalWrittenHours: 0,
    totalHours: 0,
    volunteerHours: 0,
    pastoralCareHours: 0,
    churchStaffHours: 0,
    hotTopics: [{ label: "test", occurrence: 0 }],
  };
  const dateRangeArray = generateDateArray(dates[0], dates[1]);
  const firstDay = new Date(dateRangeArray[0].startDate);
  const lastDay = new Date(dateRangeArray[dateRangeArray.length - 1].endDate);
  reportData.forEach((report) => {
    if (
      new Date(report.reportPeriodDate) >= firstDay &&
      new Date(report.reportPeriodDate) <= lastDay
    ) {
      report.hotTopics &&
        report.hotTopics.forEach((topic) => {
          if (
            !dashboardData.hotTopics.some(
              (hotTopic) =>
                hotTopic.label.trim().toLowerCase() ===
                topic.trim().toLowerCase()
            )
          ) {
            dashboardData.hotTopics.push({
              label: topic.trim().toLowerCase(),
              occurrence: 1,
            });
          } else {
            dashboardData.hotTopics.forEach((hotTopic) => {
              if (
                hotTopic.label.trim().toLowerCase() ==
                topic.trim().toLowerCase()
              ) {
                hotTopic.occurrence += 1;
              }
            });
          }
        });

      dashboardData.adminAndMeetingHours += report.adminAndMeetingsHours ?? 0;
      dashboardData.personalDevelopment +=
        report.professionalDevelopmentHours ?? 0;

      dashboardData.totalHours += report.totalPastoralHours ?? 0;

      if (!Number.isNaN(report.totalInPersonHours)) {
        dashboardData.totalInPersonHours += report.totalInPersonHours ?? 0;
        dashboardData.totalWrittenHours +=
          report.totalPastoralHours - report.totalInPersonHours ?? 0;
      }

      if (report.totalPastoralHours && report.involvement === "volunteer") {
        dashboardData.volunteerHours += report.totalPastoralHours ?? 0;
      }
      if (report.totalPastoralHours && report.involvement === "pastoralCare") {
        dashboardData.pastoralCareHours += report.totalPastoralHours ?? 0;
      }
      if (report.totalPastoralHours && report.involvement === "churchStaff") {
        dashboardData.churchStaffHours += report.totalPastoralHours ?? 0;
      }
    }
  });
  for (let key in dashboardData) {
    if (typeof dashboardData[key] === "number") {
      dashboardData[key] = Math.round((dashboardData[key] as number) * 10) / 10;
    }
  }
  return dashboardData;
};

//itterates through the time periodes and returns an array of the total hours for each date
export function calculateTotalHours(
  dateCategories: DateRange[],
  reportsMatchingUserAndDate: ReportData[],
  fields: (keyof ReportData)[]
): number[] {
  //create an array of numbers for each date category
  return dateCategories.map((dateRange) => {
    const total = reportsMatchingUserAndDate.reduce(
      (acc: number, report: ReportData) => {
        //if report matches the date category
        if (
          new Date(report.reportPeriodDate) >= dateRange.startDate &&
          new Date(report.reportPeriodDate) <= dateRange.endDate
        ) {
          //return the some of all values of the fileds
          return (
            acc +
            fields.reduce(
              (fieldAcc: number, field: keyof ReportData) =>
                fieldAcc + Number(report[field] || 0),
              0
            )
          );
        }
        return acc; // Ensure a value is returned for every branch
      },
      0
    ); // Initial value for the accumulator
    return Math.round(total * 10) / 10;
  });
}

export function organizeReportsImportInBuckets(reports: ReportData[]) {
  const buckets: CampusReportBucket[] = [];
  const newReports = [...reports];
  reports.forEach((report, index) => {
    const bucket = buckets.find(
      (bucket) => bucket.bucketId === report.bucketId
    );
    if (bucket && Object.keys(bucket.reports).length < 300) {
      //add the report to the bucket.reports object with a key of it's reportId
      bucket.reports[report.reportId] = report;
      newReports[index].bucketId = report.bucketId;
    } else {
      buckets.push({
        bucketId: generateRandomString(),
        teamId: report.teamId,
        reports: { [report.reportId]: report },
      });
      newReports[index].bucketId = report.bucketId;
    }
  });
  return newReports;
}

export const emptyReport: ReportData = {
  firstName: "",
  lastName: "",
  email: "",
  location: "",
  teamId: "",
  involvement: "",
  totalInPersonHours: 0,
  totalPastoralHours: 0,
  reportPeriodDate: "",
  lastEditDate: "",
  reportId: "",
  userId: "",
  bucketId: "",
  importedData: false,
  hotTopics: [],
  adminAndMeetingsHours: 0,
  professionalDevelopmentHours: 0,
  crisisHours: 0,
  relationshipHours: 0,
  lifeSkillsHours: 0,
  traumaHours: 0,
  addNeedsHours: 0,
  healthHours: 0,
  mentalHealthHours: 0,
  prepAndEnrichAppointments: 0,
  weedingsConducted: 0,
  newPornAddictions: 0,
  newDFVIncidents: 0,
  funeralsConducted: 0,
  hospitalVisits: 0,
  suicidalIdeation: 0,
  nonSuicidalSelfInjury: 0,
  giftsFlowers: 0,
  meals: 0,
  kiloOfKindnessBags: 0,
  lostJobs: 0,
  employmentReceived: 0,
};

export function combineReports(reportDataArray: ReportData[]) {
  return reportDataArray.reduce(
    (acc: ReportData, curr: ReportData) => {
      return {
        reportPeriodDate: curr.reportPeriodDate || acc.reportPeriodDate,
        reportId: curr.reportId || acc.reportId,
        bucketId: curr.bucketId || acc.bucketId,
        lastEditDate: curr.lastEditDate || acc.lastEditDate,
        userId: curr.userId || acc.userId,
        firstName: curr.firstName || acc.firstName,
        lastName: curr.lastName || acc.lastName,
        email: curr.email || acc.email,
        location: curr.location || acc.location,
        teamId: curr.teamId || acc.teamId,
        involvement: curr.involvement || acc.involvement,
        importedData: curr.importedData || acc.importedData,
        hotTopics: curr.hotTopics || acc.hotTopics,

        adminAndMeetingsHours:
          (acc.adminAndMeetingsHours || 0) + (curr.adminAndMeetingsHours || 0),
        professionalDevelopmentHours:
          (acc.professionalDevelopmentHours || 0) +
          (curr.professionalDevelopmentHours || 0),
        crisisHours: (acc.crisisHours || 0) + (curr.crisisHours || 0),
        relationshipHours:
          (acc.relationshipHours || 0) + (curr.relationshipHours || 0),
        lifeSkillsHours:
          (acc.lifeSkillsHours || 0) + (curr.lifeSkillsHours || 0),
        traumaHours: (acc.traumaHours || 0) + (curr.traumaHours || 0),
        addNeedsHours: (acc.addNeedsHours || 0) + (curr.addNeedsHours || 0),
        healthHours: (acc.healthHours || 0) + (curr.healthHours || 0),
        mentalHealthHours:
          (acc.mentalHealthHours || 0) + (curr.mentalHealthHours || 0),

        prepAndEnrichAppointments:
          (acc.prepAndEnrichAppointments || 0) +
          (curr.prepAndEnrichAppointments || 0),
        weedingsConducted:
          (acc.weedingsConducted || 0) + (curr.weedingsConducted || 0),
        newPornAddictions:
          (acc.newPornAddictions || 0) + (curr.newPornAddictions || 0),
        newDFVIncidents:
          (acc.newDFVIncidents || 0) + (curr.newDFVIncidents || 0),
        funeralsConducted:
          (acc.funeralsConducted || 0) + (curr.funeralsConducted || 0),
        hospitalVisits: (acc.hospitalVisits || 0) + (curr.hospitalVisits || 0),
        suicidalIdeation:
          (acc.suicidalIdeation || 0) + (curr.suicidalIdeation || 0),
        sucideDeath: (acc.sucideDeath || 0) + (curr.sucideDeath || 0),
        childDeath: (acc.childDeath || 0) + (curr.childDeath || 0),
        stillBorn: (acc.stillBorn || 0) + (curr.stillBorn || 0),
        nonSuicidalSelfInjury:
          (acc.nonSuicidalSelfInjury || 0) + (curr.nonSuicidalSelfInjury || 0),
        giftsFlowers: (acc.giftsFlowers || 0) + (curr.giftsFlowers || 0),
        meals: (acc.meals || 0) + (curr.meals || 0),
        kiloOfKindnessBags:
          (acc.kiloOfKindnessBags || 0) + (curr.kiloOfKindnessBags || 0),
        lostJobs: (acc.lostJobs || 0) + (curr.lostJobs || 0),
        employmentReceived:
          (acc.employmentReceived || 0) + (curr.employmentReceived || 0),

        totalPastoralHours:
          (acc.totalPastoralHours || 0) + (curr.totalPastoralHours || 0),
        totalInPersonHours:
          (acc.totalInPersonHours || 0) + (curr.totalInPersonHours || 0),
      };
    },
    {
      reportPeriodDate: "",
      reportId: "",
      lastEditDate: "",
      userId: "",
      firstName: "",
      lastName: "",
      email: "",
      location: "",
      teamId: "",
      involvement: "",
      totalPastoralHours: 0,
      totalInPersonHours: 0,
    } as ReportData
  );
}
